import { Component, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { AuthenticationService } from 'services/authentication.service';
import { NavigationService } from 'services/navigation.service';
import { ChangepasswordComponent } from 'app/pages/content-layout-page/changepassword/changepassword.component';
import { MatDialog } from '@angular/material';
import { UserService } from 'services/user.service';
import { UserSessionService } from 'services/usersession.service';
import { ApplicationService } from 'services/application.service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit, AfterViewInit {
  currentLang = 'en';
  toggleClass = 'ft-maximize';
  placement = 'bottom-right';
  public isCollapsed = true;
  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  public config: any = {};
  userId: number;
  userfullname: string;
  roleId: number;
  resellerCode: string = "";

  constructor(public translate: TranslateService,
    private layoutService: LayoutService,
    private authService: AuthenticationService,
    private navigationService: NavigationService,
    public dialog: MatDialog, private userService: UserService,
    private userSessionService: UserSessionService,
    private configService: ConfigService,
    public applicationService: ApplicationService) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : 'en');
    this.userId = this.userSessionService.userId();
    this.roleId = this.userSessionService.roleId();

  }


  ngOnInit() {
    this.config = this.configService.templateConf;
    this.getusername(true);
    this.getResellerCode();

  }

  getResellerCode() {
    this.userId = this.userSessionService.userId();
    this.userService.getUserById(this.userId).subscribe((result: any) => {
      if (result) {
        this.resellerCode = result.resellerGroupCode;
      }
    });
  }

  ngAfterViewInit() {
    if (this.config.layout.dir) {
      const dir = this.config.layout.dir;
      if (dir === 'rtl') {
        this.placement = 'bottom-left';
      } else if (dir === 'ltr') {
        this.placement = 'bottom-right';
      }
    }
  }

  ChangeLanguage(language: string) {
    this.translate.use(language);
  }

  ToggleClass() {
    if (this.toggleClass === 'ft-maximize') {
      this.toggleClass = 'ft-minimize';
    } else {
      this.toggleClass = 'ft-maximize';
    }
  }

  toggleNotificationSidebar() {
    this.layoutService.emitChange(true);
  }

  toggleSidebar() {
    const appSidebar = document.getElementsByClassName('app-sidebar')[0];
    if (appSidebar.classList.contains('hide-sidebar')) {
      this.toggleHideSidebar.emit(false);
    } else {
      this.toggleHideSidebar.emit(true);
    }
  }

  onLogout() {
    this.authService.logOut();
    this.navigationService.goToLogin();
  }

  openChangePasswordDialog(flag) {
    const dialogRef = this.dialog.open(ChangepasswordComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'change-password-dialog',
      // width:'40%'
      data: {
        isPasswordChange: flag
      }
    })
    dialogRef.afterClosed().subscribe(data => {

      if (data) {

      }
    });

  }
  getusername(refresh) {
    this.userService.getUser(this.userId, refresh).subscribe(result => {
      //  this.userfullname = (result.firstName[0].toUpperCase + result.substr.firstName[1].toLowerCase()) + (result.lastName[0].toUpperCase + result.substr.lastName[1].toLowerCase());
      this.userfullname = result.firstName.charAt(0).toUpperCase() + result.firstName.slice(1).toLowerCase() + ' ' + result.lastName.charAt(0).toUpperCase() + result.lastName.slice(1).toLowerCase();
      console.log(this.userfullname);

    })
  }
}
